import React from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import { capitalize } from 'lodash';
import { SelectField } from '../../../../../../common/components/ReduxFormField';
import { required, format } from 'redux-form-validators';
import {
  ADULT_TITLE_OPTIONS,
  CHILD_TITLE_OPTIONS,
} from '../../../../../../helpers/titleOptions';

const TITLES = {
  ADULT: ADULT_TITLE_OPTIONS,
  CHILD: CHILD_TITLE_OPTIONS,
};

const NameInput = ({ input, meta, placeholder }) => (
  <>
    <FormControl placeholder={placeholder} {...input} />
    {meta.touched && meta.error && <span className="input-error">{meta.error}</span>}
  </>
);
const NameFields = ({
  baseName,
  label,
  labelSize,
  hideTitle,
  infoButton,
  isChild = false,

  clearable = false,
}) => {
  const titles = isChild ? TITLES.CHILD : TITLES.ADULT;

  const fieldSize = 12 - (labelSize || 2);
  const upper = (value) => {
    if (!value) {
      return value;
    }
    return value
      .split(' ')
      .map((val) => capitalize(val))
      .join(' ');
  };
  return (
    <FormGroup>
      <Col sm={labelSize || 2}>
        <ControlLabel>
          {label} {infoButton}
        </ControlLabel>
      </Col>
      <Col sm={fieldSize}>
        <div>
          {!hideTitle && (
            <Col sm={2} className="name-fields">
              <Field
                clearable={clearable}
                name={baseName + '.title'}
                placeholder="Title"
                options={titles}
                component={SelectField}
                validate={required({ msg: 'Title is required' })}
              />
            </Col>
          )}
          <Col sm={hideTitle ? 4 : 3} className="name-fields">
            <Field
              name={baseName + '.first_name'}
              placeholder="First name"
              normalize={upper}
              component={NameInput}
              validate={[
                required({ msg: 'Name is required' }),
                format({
                  with: /^[a-z,'-]+$/i,
                  message: 'Only allows letters, ' + 'hyphen and apostrophe allowed',
                }),
              ]}
            />
          </Col>
          <Col sm={hideTitle ? 4 : 3} className="name-fields">
            <Field
              name={baseName + '.last_name'}
              placeholder="Surname"
              component={NameInput}
              normalize={upper}
              validate={[
                required({ msg: 'Surname is required' }),
                format({
                  with: /^[a-z,'-]+$/i,
                  message: 'Only allows letters, ' + 'hyphen and apostrophe allowed.',
                }),
              ]}
            />
          </Col>
        </div>
      </Col>
    </FormGroup>
  );
};

export default NameFields;
